import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-invalid-forgetpassword-link',
  templateUrl: './invalid-forgetpassword-link.component.html',
  styleUrls: ['./invalid-forgetpassword-link.component.css']
})
export class InvalidForgetpasswordLinkComponent implements OnInit {

  constructor(private globalSrv: GlobalServices,) { }

  ngOnInit() {
  }
  goToHome() {
    this.globalSrv.goToHome();
  }
}
